import { render, staticRenderFns } from "./SuspendReincorporateDialog.vue?vue&type=template&id=80f1be16&scoped=true"
import script from "./SuspendReincorporateDialog.vue?vue&type=script&lang=js"
export * from "./SuspendReincorporateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f1be16",
  null
  
)

export default component.exports